import { FEATURE_FLAGS } from "@solomon-apps/config";
import type { YaasWalletResponse } from "@solomon-apps/shared/src/types/yaas";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import { yaasWalletQueryKey } from "./queryKeys";
import { fetchWalletView, mergeWalletViews } from "./walletView";

/** Account, status and LP readers share a single request and owner-scoped cache. */
export function useWalletView(
    address: string | null | undefined,
    enabled: boolean
): ReturnType<typeof useQuery<YaasWalletResponse, Error>> {
    const client = useQueryClient();
    const key = yaasWalletQueryKey(address ?? undefined);
    return useQuery<YaasWalletResponse, Error>({
        queryKey: key,
        queryFn: async ({ signal }) => {
            if (!address) throw new Error("No wallet address");
            return mergeWalletViews(
                client.getQueryData<YaasWalletResponse>(key),
                await fetchWalletView(address, signal)
            );
        },
        enabled: enabled && !!address,
        staleTime: FEATURE_FLAGS.retailLpApiDiscovery ? 10_000 : 60_000,
        refetchInterval: FEATURE_FLAGS.retailLpApiDiscovery ? 10_000 : 60_000,
        retry: 1
    });
}
